import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden bg-hero-gradient px-5 pb-10 pt-10 md:pb-[70px] md:pt-[60px] text-center" data-id="element-102">
      {/* Background glow */}
      <div className="pointer-events-none absolute left-1/2 top-[-80px] h-[700px] w-[700px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(230,57,70,0.12)_0%,transparent_70%)]" data-id="element-103" />

      <div className="relative z-10 mx-auto max-w-6xl" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-6 inline-block rounded-[3px] bg-brandRed px-[18px] py-[7px] font-montserrat text-[11px] font-extrabold uppercase tracking-[2.5px] text-white" data-id="element-105">
          Sistema N°1 para odontólogos independientes argentinos
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mb-2.5 font-bebas text-[clamp(42px,7vw,82px)] leading-none tracking-[1px] text-white" data-id="element-106">
          Tu Consultorio
          <br data-id="element-107" />
          <span className="text-gold" data-id="element-108">En Orden</span>
          <br data-id="element-109" />
          En 7 Días
        </motion.h1>

        {/* Product Mockup Image — scaled to ~70% */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="mx-auto mb-3 mt-2 max-w-[540px]" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/mxpBCdDXtEPrZvG574zSbH/MOCKUP_PRINCIPAL_ODONTOLOGIA.png" alt="Mockup del Kit Consultorio en Orden con tomos, plantillas y bonos" width={1080} height={1080} loading="eager" decoding="async" fetchPriority="high" className="h-auto w-full drop-shadow-2xl" data-id="element-111" />
        </motion.div>

        {/* Small supporting note below the mockup */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="mx-auto mb-7 max-w-[480px] font-montserrat text-[11px] font-medium leading-snug text-white/45" data-id="element-112">
          En 7 días tu consultorio tiene protocolos funcionando. En 30 días ya
          no depende de tu memoria.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="mx-auto mb-6 md:mb-[36px] max-w-[680px] font-montserrat text-[clamp(15px,2.5vw,20px)] font-medium leading-relaxed text-white/80" data-id="element-113">
          El primer sistema de protocolos clínicos completo para odontólogos
          independientes argentinos. Descargalo hoy, implementalo esta semana.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="mb-6 md:mb-[36px] flex flex-wrap justify-center gap-2.5" data-id="element-114">
          {['PDF Digital', 'Acceso Inmediato', 'Consultorio Independiente', 'Mercado Pago'].map(tag => <span key={tag} className="rounded-full border border-white/15 bg-white/5 px-[14px] py-[6px] font-montserrat text-[12px] font-semibold tracking-[0.5px] text-white/70" data-id="element-115">
              {tag}
            </span>)}
        </motion.div>

        <motion.a initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} href="#oferta" className="inline-block rounded-md bg-btn-red px-[44px] py-[18px] font-montserrat text-[clamp(14px,2.5vw,18px)] font-black uppercase tracking-[0.5px] text-white shadow-[0_8px_32px_rgba(230,57,70,0.45)] transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(230,57,70,0.55)]" data-id="element-116">
          💥 QUIERO MI CONSULTORIO EN ORDEN AHORA
        </motion.a>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-5 flex flex-wrap justify-center gap-5" data-id="element-117">
          {['✓ Garantía 7 días', '✓ Pago seguro', '✓ Listo para usar el lunes', '✓ Hecho para Argentina'].map(trust => <span key={trust} className="font-montserrat text-[12px] font-medium text-white/55" data-id="element-118">
              {trust}
            </span>)}
        </motion.div>
      </div>
    </section>;
}